import { Injectable, Type } from "@angular/core";
import { PromiseBlotterLookupService } from "../../impl/PromiseBlotterLookupService";
import { IRiskTradePromiseLookupService } from "../IRiskTradePromiseLookupService";
import { IBasePrimeDependent } from "../../IBasePrimeDependent";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export abstract class RiskTradePromiseLookupService
  extends PromiseBlotterLookupService<string, CubiqTS.DealImpl>
  implements IRiskTradePromiseLookupService, IBasePrimeDependent
{
  abstract addDependentPrime(dependentIsPrimed: Promise<boolean>): Promise<boolean>;
}
